import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import AnumImg from '../assets/images/Anum.png'

const Anum = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Anum - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={AnumImg}
                    Title="Anum"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971504948130"
                    PhoneNumber="+971 50 494 8130"
                    WhatsappLink="971504948130"
                    Whatsapp="+971 50 494 8130"
                    Email="anum@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={AnumImg}
                    Title="Anum"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971504948130"
                    PhoneNumber="+971 50 494 8130"
                    WhatsappLink="971504948130"
                    Whatsapp="+971 50 494 8130"
                    Email="anum@800homes.ae"
                />
            </section>
        </>
    )
}

export default Anum
